module.exports = "/packs/images/products/basic-kit@3x-9f1c080843f642ccf80174928a7c9aba.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/basic-kit@3x.png
// module id = 970
// module chunks = 0 1